module.exports = __webpack_public_path__ + "img/icon-sleep-time-4.c2d6e026.svg";